import { PayoutInfo as KitPayoutInfo } from "lola-framework-ui-test";
import type { JSX } from "react";

export interface PayoutInfoProps {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  onChange?: () => void;
  color?: string;
  fee?: string | JSX.Element;
  className?: string;
}

export const PayoutInfo: React.FC<PayoutInfoProps> = ({
  title,
  subtitle,
  icon,
  onChange,
  color = "#252525",
  fee,
  className = "",
}) => (
  <KitPayoutInfo
    title={title}
    subtitle={subtitle}
    icon={icon}
    onChange={onChange}
    iconColor={color}
    fee={fee}
    className={className}
    showBackArrow={!fee}
  />
);
